module.exports = __webpack_public_path__ + "img/10.ede96399.jpg";